import { cardContainerStyles } from "@insite/content-library/Components/CardContainer";
import { css } from "styled-components";

cardContainerStyles.cardDivider = {
    css: css`
        width: calc(100% - 20px);
        margin: 0 0px;
        border-bottom: 0;
    `,
};
